import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react';
import { PageHeader } from 'react-bootstrap';
import { withErrorBoundary } from 'react-error-boundary';
import useMobxStores from 'hooks/useMobxStores';
import EditClass from 'components/Classes/Edit';
import { handleError } from '../../../services/ErrorService';
import GenericViewError from '../../../components/Error/GenericViewError';
import ViewLoader from '../../../components/Loading/View';

const EditClassView = () => {
  const { routerStore } = useMobxStores();
  const { uuid, title } = routerStore?.route?.params;

  return (
    <>
      {title && <Helmet title={`${title} - Red Hat Learning`} />}
      <div className="container-grid-responsive">
        <PageHeader>{title}</PageHeader>
        <React.Suspense fallback={<ViewLoader />}>
          <EditClass {...(uuid && { uuid })} />
        </React.Suspense>
      </div>
    </>
  );
};

export default withErrorBoundary(
  observer(EditClassView),
  GenericViewError,
  handleError,
);
